import LocalAuth0Service from '@/services/LocalAuth0Service'
import genericOps from '@/mixins/genericOps'
import { getInstance } from "./index";
import store from '../store/store'
import TaskService from "../services/TaskService";
import UserService from "../services/UserService";


export const authGuard = (to, from, next) => {
  // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed debug console.log
  
  const authService = getInstance();

  const fn = async () => {
    // If the user is authenticated, continue with the route
    if (authService.isAuthenticated) {

      // console.log('authGuard.fn - to = ')
      // console.log(to)

      

      // Override for development playground pages.
      if(to.name == 'stripe-demo') {

        let tempToken = await authService.auth0Client.getTokenSilently()
  
        // Set the minimum information the app needs to start gathering data
        store.commit('SET_USER', {email: authService.user.email})
        store.commit('SET_USER_TOKEN', tempToken)
        
        await store.dispatch('loadUser')

        return next()
         
      
      // The signup page handles all the logic included here so skip.
      } else if(to.name != 'signup') {

        // If the user is dirty then the app doesn't have all of the information it needs to function.
        if(store.getters.getUserDirty) {

          let tempToken = await authService.auth0Client.getTokenSilently()
  
          // Set the minimum information the app needs to start gathering data
          store.commit('SET_USER', {email: authService.user.email})
          store.commit('SET_USER_TOKEN', tempToken)

          // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed console.log of user data
          // WHY: User data should not be logged to browser console

          await store.dispatch('loadUser').catch((e) => {
            // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed console.log
            // WHY: Error will be handled by caller

          });
          
          // If the user is still dirty then they haven't completed sign-up.
          if(store.getters.getUserDirty) {

            return next('/signup');

          } else {

            // 20260405 -- Copilot (Claude Sonnet 4.6) -- Record lastLoggedIn on explicit logins only
            // WHY: isFreshLogin is only set on real login callbacks, not on silent token refresh or page reload
            if(authService.isFreshLogin) {
              authService.isFreshLogin = false;
              UserService.recordLogin(tempToken).catch(() => {});
            }

            // 20260413 -- Copilot (Claude Sonnet 4.6) -- Record daily activity for streak and active-days tracking
            // WHY: localStorage gate ensures one API call per calendar day regardless of navigation frequency
            const _activityToday = new Date().toISOString().slice(0, 10);
            if (localStorage.getItem('pt_activity_date') !== _activityToday) {
              localStorage.setItem('pt_activity_date', _activityToday);
              UserService.recordActivity(tempToken).catch(() => {});
            }
            
            // If navigating to a premium page, check whether user has access.

            if(to.path == '/gallery/personal') {

              if(!genericOps.methods.isPremiumUser()) {
                return next({name: 'profile'
                  , params: {section: 'subscription'
                    , message: {title: 'Upgrade', body: 'You must upgrade to a paid subscription to use this feature.', variant: 'warning'}}})
              }

            }

            // console.log('Interrogating Auth0 data...')
            
            let appMetaData = authService.user['https://www.principaltask.com/app_metadata'] || {}
            
            if((typeof appMetaData.pt_user_id == 'undefined' || appMetaData.pt_user_id === null) || appMetaData.pt_user_id != store.getters.getUser._id) {

              let updates = {
                "app_metadata": {
                  "pt_user_id": store.getters.getUser._id
                }
              }
    
              await LocalAuth0Service.updateUser(tempToken, updates)
              
              tempToken = await authService.auth0Client.getTokenSilently()
              store.commit('SET_USER_TOKEN', tempToken)

            }
            
            // 20201019 -- ZWS -- May want to load this as necessary 
            // since a user may not be going to tasks first.
            await store.dispatch('loadContexts')
            await store.dispatch('loadFolders')
            
            /*

            20200201 -- ZWS -- Is there any reason to load tasks this early?
            
            let filter = store.getters.getUserPrefs.taskFilter
            TaskService.refineTaskFilter(filter)
            await store.dispatch('loadTasks', filter.refinedFilter)

            */
  
            return next();
          
          }
  
          
  
        } else {
          // 20260413 -- Copilot (Claude Sonnet 4.6) -- Record daily activity when user is already loaded (subsequent navigations)
          // WHY: getUserDirty is false on all navigations after the first load, so the ping must also fire here
          const _activityToday = new Date().toISOString().slice(0, 10);
          if (localStorage.getItem('pt_activity_date') !== _activityToday) {
            localStorage.setItem('pt_activity_date', _activityToday);
            const _activityToken = store.state.userToken;
            if (_activityToken) UserService.recordActivity(_activityToken).catch(() => {});
          }
        }

      }

      return next();
      
      

      
      
    }

    // Otherwise, log in

    

    let action = to.query["action"] == "signup" ? "signup" : "login"

    // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed debug console.log

    authService.loginWithRedirect({ 
      appState: { 
        targetUrl: to.fullPath 
      },
      action: action
    });
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};